import { apiClient } from '@/services/ApiClient.js'

import { query_builder } from '../../utilities/helpers'

export default {
  getApplications(query) {
    return apiClient
      .get('applications', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getStatistics(query) {
    return apiClient
      .get('applications/statistics', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getApplication(id) {
    return apiClient
      .get('applications/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  assign(applicationId, params) {
    return apiClient
      .post('applications/' + applicationId + '/assign', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  saveMuLimit(applicationId, amount) {
    return apiClient
      .post('applications/' + applicationId + '/save-mu-limit', amount)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getAnswers(applicationId) {
    return apiClient
      .get('applications/' + applicationId + '/answers')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getActivities(applicationId) {
    return apiClient
      .get('applications/' + applicationId + '/activities')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getDecisionReasons() {
    return apiClient
      .get('applications/decision-reasons')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCreditReports(applicationId) {
    return apiClient
      .get('applications/' + applicationId + '/credit-reports')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteDecision(applicationId, decisionId) {
    return apiClient
      .delete('applications/' + applicationId + '/decisions/' + decisionId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportKit(query, allowedFilters, kit) {
    let queryStringWithUrl = query_builder('applications/export-kit', query, allowedFilters)

    return apiClient
      .post(queryStringWithUrl.build(), {
        export_kit: kit
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateBusinessNumber(id, businessNumber) {
    return apiClient
      .patch('applications/' + id + '/update-business-number', {
        business_number: businessNumber
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  transition(id, state, params) {
    return apiClient
      .post('applications/' + id + '/transition', {
        ...params,
        target_state: state
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  documentWaiting(id, state) {
    return apiClient
      .post('applications/' + id + '/document-waiting')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  fraudDecision(id, params) {
    return apiClient
      .post('applications/' + id + '/fraud-decision', {
        ...params
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  saveRequiredDocuments(id, documents) {
    return apiClient
      .post('applications/' + id + '/save-required-documents', {
        documents
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadRequiredDocuments(id, files) {
    let formData = new FormData()

    files.forEach((file, index) => {
      formData.append('files[' + index + ']', file.file)
      formData.append('types[' + index + ']', file.type)
    })

    return apiClient
      .postForm('applications/' + id + '/upload-required-documents', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewRequiredDocument(id, document) {
    return apiClient
      .get('applications/' + id + '/required-documents/' + document.id, {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: document.content_type })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  downloadRequiredDocument(id, document) {
    return apiClient
      .get('applications/' + id + '/required-documents/' + document.id, {
        responseType: 'blob'
      })
      .then(response => {
        return response
      })
      .catch(err => {
        if (
          err.request.responseType === 'blob' &&
          err.response.data instanceof Blob &&
          err.response.data.type &&
          err.response.data.type.toLowerCase().indexOf('json') != -1
        ) {
          return new Promise((resolve, reject) => {
            let reader = new FileReader()
            reader.onload = () => {
              err.response.data = JSON.parse(reader.result)
              resolve(Promise.reject(err))
            }

            reader.onerror = () => {
              reject(err)
            }

            reader.readAsText(err.response.data)
          })
        }
        throw err
      })
  },
  getFarmerDocuments(id) {
    return apiClient
      .get('applications/' + id + '/farmer-documents')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteRequiredDocument(documentId) {
    return apiClient
      .delete('order-documents/' + documentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  async getApiaProduction(id) {
    return apiClient.get(`applications/${id}/apia-production`)
  }
}
